import { styled } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'

export const Root = styled(Box)(() => ({
  textAlign: 'center',
}))
